import useUI from 'hooks/use-ui';
import useViewport from 'hooks/use-viewport';
import { useIsFullscreenModal } from 'components/modals/use-is-fullscreen-modal';

export type ContainerProps = {
  isIframe: boolean;
  iframeOffset: number;
  parentOffset: number;
  viewportHeight: number;
  viewportWidth: number;
  iframeHeight: number;
  /**
   * Fills the entire iframe viewport instead of a small centered card — the
   * embedded (iframe) AI Concierge takeover from ECOMM-12300. `isIframe &&
   * UI.isConciergeActive`: any modal opened while embedded AND on the
   * concierge route. Storefront concierge (not embedded) and tall
   * auto-resized embedded menus (embedded but not on the concierge route)
   * both stay `false` and keep the existing centered-card modal.
   */
  fullscreen: boolean;
};

export function useContainerProps(): ContainerProps {
  const UI = useUI();
  const viewport = useViewport();
  const fullscreen = useIsFullscreenModal();

  return {
    isIframe: UI.isIframe,
    iframeOffset: viewport.offset,
    parentOffset: viewport.parentOffset,
    viewportHeight: viewport.height,
    viewportWidth: viewport.width,
    iframeHeight: UI.iframeHeight,
    fullscreen,
  };
}
